import { Box, Flex, SimpleGrid } from "@chakra-ui/react";
import { Content } from "~/api/resources/Contents";
import { Subheading } from "./Text/Subheading";
import { ReactMarkdown } from "./Text";
import { TheWindingRoute } from "./TheWindingRoute";

type Props = {
  contents: Content[];
  content_type_name: string;
  title?: string;
};

export const ContentLinkList = ({
  contents,
  content_type_name,
  title,
}: Props) => {
  const content = contents.find(
    (c) => c.content_type_slug === content_type_name
  );

  if (!content) return null;
  return (
    <Box mt={24}>
      <SimpleGrid
        columns={{ base: 1, lg: 2 }}
        rowGap={16}
        alignItems={"flex-end"}
      >
        <TheWindingRoute
          h={195}
          ml={{ base: 104, lg: 152 }}
          order={{ base: 0, lg: 1 }}
        />
        <Box
          borderBottom="3px solid"
          borderColor="green.500"
          py={6}
          // pl={{ base: "40px", md: "104px" }}
          px={24}
        >
          <Subheading fontSize={{ base: "4xl", md: "4xl" }} w="100%">
            {title || `Annual events in this community`}
          </Subheading>
        </Box>
      </SimpleGrid>

      <Flex
        // align="center"
        // justify={{ base: "flex-start", lg: "center" }}
        px={24}
      >
        <SimpleGrid
          columns={{ base: 1, lg: 2 }}
          columnGap={24}
          rowGap={6}
          py={20}
        >
          <ReactMarkdown
            linkProps={{
              color: "gray.900",
              fontFamily: "heading",
              fontSize: "3xl",
              fontWeight: "normal",
            }}
            format_children={false}
          >
            {content.html ?? content.description ?? ""}
          </ReactMarkdown>
        </SimpleGrid>
      </Flex>
    </Box>
  );
};
